// extracted by mini-css-extract-plugin
export var container = "transition-dashboard-module--container--H4WTL";
export var header = "transition-dashboard-module--header--WWQ9e";
export var reports = "transition-dashboard-module--reports--0iA2U";